import { registerSW } from 'virtual:pwa-register';

/**
 * Register the service worker and reload once a new version is ready.
 * autoUpdate strategy — Workbox swaps in the new SW without a prompt.
 */
export function initPwa() {
  if (import.meta.env.DEV) return;
  registerSW({
    immediate: true,
    onRegisteredSW(_swUrl, registration) {
      if (registration) {
        // Re-check for updates hourly while the app is open.
        setInterval(() => registration.update().catch(() => {}), 60 * 60 * 1000);
      }
    },
  });
}
